import React, { useEffect, useMemo, useState } from "react";
import { useTable, useSortBy } from "react-table";

import { OverlayTrigger, Tooltip } from "react-bootstrap";
import PaginationAndSearching from "../../components/Pagination Component/paginationAndSearching";
import SkeletonTableRow from "../../components/SkeltonTable/skeletonTable";
import { useDispatch, useSelector } from "react-redux";
import PropertyListPage from "./propertyListPage";
import { getUserByPropIdApi } from "../../../service/property/getUserByPropId";
import { formatDate } from "../../../function/commonFunction";
import ExpiryDateFilter from "./ExpiryDateFilter";
import { Button } from "@mui/material";
import { setLoading } from "../../../feature/authSlice";
import { findSubMenuByName } from "./MenuUtlis";
import { maskGSTIN } from "../auth/maskingFunction";
//import './table.css';

export const CancelledPropertyListTable = ({
  column,
  rowsArr,
  handleVerify,
  handleSearchPagination,
  searchValuePagination,
  pageSizePagination,
  handleChangeRowsPerPagePagination,
  totalCountPagination,
  handleOnChangePagination,
  showLoading,
  handleDeleteById,
  handleTabExpanded,
  userArr,
  handleSeeVendor,
  totalCount,
  handleActionPending,
  onLoadData,
  fromDate,
  toDate,
  setFromDate,
  setToDate,
  setPageSizeCancelled,
  setFilterType
}) => {
  const {permissionArr} = useSelector(state =>state.auth)
  const {permissions} = useSelector(state =>state.permissionsData)

  const dispatch = useDispatch()
  const columns = useMemo(() => column, []);
  const data = useMemo(() => rowsArr, [rowsArr]);
  const userData = useMemo(() => userArr, [userArr]);

  const tableInstance = useTable({ columns, data }, useSortBy);
useEffect(()=>{},[userArr])
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    //footerGroups,
    rows,
    prepareRow,
  } = tableInstance;
  const [expandedRowIndex, setExpandedRowIndex] = useState(null);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
 
  const toggleRowExpansion = (index) => {
    setExpandedRowIndex((prevIndex) => (prevIndex === index ? null : index));
  };
const [userArray,setUserArray] = useState([])
  function handleUserData(val)  {
setUserArray([])
    var data  ={
      // PropertyId:val.Id
      "Filter": "",
      "OrderBy": "",
      "PageSize": 0,
      "PageNumber": 0,
      "Keyword": '',
      "PropertyId": val.Id
    }
    dispatch(getUserByPropIdApi(data,(res)=>{
      // console.log(res.data?.result)
      setUserArray(res.data?.result.List)
    },()=>{}))
  }

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };


  // Helper function to check if a specific action exists in a submenu
  const hasAction = (submenu, actionName) => submenu?.Actions.includes(actionName);

  // Find the "Properties" menu
  const propertiesMenu = findSubMenuByName(permissions, 'Properties');
  const listPropertyMenu = propertiesMenu ? findSubMenuByName(propertiesMenu?.SubMenus, 'List Property') : null;
  const approvedSubMenu = listPropertyMenu ? findSubMenuByName(listPropertyMenu?.SubMenus, 'Rejected') : null;
  // Check actions in the "Approved" submenu
  const canApprove = approvedSubMenu ? hasAction(approvedSubMenu, 'Approve') : false;
  const canSearch = approvedSubMenu ? hasAction(approvedSubMenu, 'Search') : false;
  const canMoreFilter = approvedSubMenu ? hasAction(approvedSubMenu, 'MoreFilter') : false;
  const canAudittrial = approvedSubMenu ? hasAction(approvedSubMenu, 'Audittrial') : false;
  const canActive = approvedSubMenu ? hasAction(approvedSubMenu, 'Active') : false;
  const canReject = approvedSubMenu ? hasAction(approvedSubMenu, 'Reject') : false;
  const canAssignUsers = approvedSubMenu ? hasAction(approvedSubMenu, 'AssignUsers') : false;
  const canViewUsers = approvedSubMenu ? hasAction(approvedSubMenu, 'ViewUsers') : false;
  const canViewVendors = approvedSubMenu ? hasAction(approvedSubMenu, 'ViewVendors') : false;
  const MoreFilterSubMenu = approvedSubMenu ? findSubMenuByName(approvedSubMenu?.SubMenus, 'MoreFilters') : null;
  const invoiceType = MoreFilterSubMenu ? hasAction(MoreFilterSubMenu, 'InvoiceType') : false;
  const expiryDate = MoreFilterSubMenu ? hasAction(MoreFilterSubMenu, 'ExpiryDate') : false;

  const handlePageSizeChange=(event)=>{
    setPageSizeCancelled(event.target.value)
    }

    const [type, setTpe] = React.useState(permissionArr.some(role => /(telephone|admin)/i.test(role))?'Telephone':"Maintenance/Electricity");
    const handleChange = (event) => {
      setTpe(event.target.value);
    };

    useEffect(() => {
      setFilterType(type)
    }, [type])

  return (
    <>

      <div className="card">
        <div className="card-header">
          <h3></h3>
          {/* <div className='pagination-search-container'>
                    <div className="service-input-group input-group">
                        <span className="input-group-text search-input-icon">

                            <i className="bi bi-search" style={{ fontSize: '16px' }}></i>
                        </span>
                        <input
                            type="text"
                            className="form-control search-input"
                            id="val-username1"
                            placeholder="Search..."
                            name="username"
                            value={searchValuePagination}
                            onChange={handleSearchPagination}
                        />
                        </div>
                    </div> */}
        </div>
        <div className="card-body">
        <h4> Total Rejected Property : &nbsp; {totalCount}</h4> <div className="d-flex justify-content-end">
        {canSearch&&(
            <div className="service-input-group input-group" style={{width:"220px"}}>
                        <span className="input-group-text search-input-icon">

                            <i className="bi bi-search" style={{ fontSize: '16px' }}></i>
                        </span>
                        <input
                            type="text"
                            className="form-control search-input"
                            id="val-username1"
                            placeholder="Search..."
                            name="username"
                            value={searchValuePagination}
                            onChange={handleSearchPagination}
                        />
                    </div>
        )}
             {MoreFilterSubMenu&&(
                    <Button
        id="demo-positioned-button"
        aria-controls={open ? 'demo-positioned-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
        sx={{
          textTransform:'none'
        }}
      >
        More Filters<span class="material-icons">
arrow_drop_down
</span>
      </Button>
             )}
 <ExpiryDateFilter
 onLoadData={()=>{
  onLoadData("InvoiceList",type)
  handleClose()
}}
 open={open}
 fromDate={fromDate}
 toDate={toDate}
 setFromDate={setFromDate}
 anchorEl={anchorEl}
 handleClose={handleClose}
 setToDate={setToDate}
 type={type}
 handleChange={handleChange}
 isVendorList={true}
 showInvoiceType={invoiceType}
 showExpDate={expiryDate}
 />
            </div>
                    <div className="table-responsive">
  <div className="dataTables_wrapper">
    <table {...getTableProps()} className="table dataTable display">
      <thead>
        {headerGroups.map((headerGroup) => (
          <tr {...headerGroup.getHeaderGroupProps()}>
            {headerGroup.headers.map((column) => (
              <th
                {...column.getHeaderProps(column.getSortByToggleProps())}
                style={{ color: "rgba(23, 90, 169, 0.78)" }}
              >
                {column.render("Header")}
                <span className="ml-1">
                  {column.isSorted ? (
                    column.isSortedDesc ? (
                      <i
                        className="fa fa-arrow-down ms-2 fs-14"
                        style={{ opacity: "0.7" }}
                      />
                    ) : (
                      <i
                        className="fa fa-arrow-up ms-2 fs-14"
                        style={{ opacity: "0.7" }}
                      />
                    )
                  ) : (
                    <i
                      className="fa fa-sort ms-2 fs-14"
                      style={{ opacity: "0.3" }}
                    />
                  )}
                </span>
              </th>
            ))}
          </tr>
        ))}
      </thead>
      <tbody {...getTableBodyProps()}>
        {rows.map((row, rowIndex) => {
          prepareRow(row);
          return (
            <>
              <tr {...row.getRowProps()}>
                {row.cells.map((cell, cellIndex) => {
                  const isLastColumn = cellIndex === row.cells.length - 2;
                  const actionColumn = cellIndex === row.cells.length - 1;
                  const GSTIN = cellIndex === 5;
                  const date = cellIndex === 6;
                  const vendorName = cellIndex === 8;

                  return (
                    <td
                      {...cell.getCellProps()}
                      style={{ color: "black", whiteSpace: "normal" }}
                    >
                      {isLastColumn ? (
                        <div style={{ textAlign: "center" }}>
                          {canViewUsers&& (
                            <i
                              className="material-icons"
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                if (expandedRowIndex !== rowIndex) {
                                  handleTabExpanded(row.original);
                                  handleUserData(row.original);
                                }
                                toggleRowExpansion(rowIndex);
                              }}
                            >
                              {expandedRowIndex === rowIndex ? "remove" : "add"}
                            </i>
                          )}
                        </div>
                      ) : GSTIN ? (
                        <div className="d-flex">
                          {maskGSTIN(cell.value)}
                          <span
                            className="material-icons"
                            style={{
                              color: "green",
                              fontSize: "17px",
                              marginLeft: "2px",
                            }}
                          >
                            check_circle
                          </span>
                        </div>
                      ) : vendorName ? (
                        canViewVendors && (
                          <div style={{ textAlign: "center" }}>
                            <span
                              className="material-icons"
                              style={{ cursor: "pointer" }}
                              onClick={() => handleSeeVendor(row.original,'rejected')}
                            >
                              visibility
                            </span>
                          </div>
                        )
                      ) : date ? (
                        formatDate(row.original.LeaseEndDate)
                      ) : actionColumn ? (
                        <>
                          {canAudittrial && (
                            <OverlayTrigger
                              placement="top"
                              overlay={
                                <Tooltip id="tooltip">{"Audit"}</Tooltip>
                              }
                            >
                              <i
                                className="material-icons"
                                style={{
                                  color: "rgba(23, 90, 169, 0.78)",
                                  marginRight: "6px",
                                  cursor: "pointer",
                                }}
                                onClick={() => {
                                  handleActionPending(
                                    row.original.Id,
                                    "audit",
                                    row.original
                                  );
                                }}
                              >
                                history
                              </i>
                            </OverlayTrigger>
                          )}
                          {canActive && (
                            <OverlayTrigger
                              placement="top"
                              overlay={
                                <Tooltip id="tooltip">{"Active"}</Tooltip>
                              }
                            >
                              <i
                                className="material-icons"
                                style={{
                                  color: "orange",
                                  marginRight: "6px",
                                  cursor: "pointer",
                                }}
                                onClick={() => {
                                  handleActionPending(
                                    row.original.Id,
                                    "active",
                                    row.original
                                  );
                                }}
                              >
                                edit
                              </i>
                            </OverlayTrigger>
                          )}
                        </>
                      ) : (
                        cell.render("Cell")
                      )}
                    </td>
                  );
                })}
              </tr>
              {expandedRowIndex === rowIndex && (
                <tr>
                  <td
                    colSpan={row.cells.length}
                    style={{ padding: 0, background: "rgb(211 211 211 / 40%)" }}
                  >
                    <table
                      style={{ width: "100%", background: "rgb(211 211 211 / 40%)" }}
                    >
                      <thead>
                        <tr>
                          <th style={{ color: "rgba(23, 90, 169, 0.78)" }}>
                            Email
                          </th>
                          <th style={{ color: "rgba(23, 90, 169, 0.78)" }}>
                            Phonenumber
                          </th>
                          <th style={{ color: "rgba(23, 90, 169, 0.78)" }}>
                            Role
                          </th>
                        </tr>
                      </thead>
                      <tbody style={{ color: "black" }}>
                        {userArray.map((item, key) => (
                          <tr key={key}>
                            <td style={{ whiteSpace: "normal" }}>{item.Email}</td>
                            <td style={{ whiteSpace: "normal" }}>{item.Phone}</td>
                            <td style={{ whiteSpace: "normal" }}>{item.Roles[0]}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                    {userArray.length === 0 && (
                      <div style={{ display: "flex", justifyContent: "center" }}>
                        No result found
                      </div>
                    )}
                  </td>
                </tr>
              )}
            </>
          );
        })}
      </tbody>
      {showLoading && <SkeletonTableRow cols={4} row={4} />}
      {rows.length === 0 && (
        <div style={{ display: "flex", justifyContent: "center" }}>
          No record found
        </div>
      )}
    </table>
  </div>
</div>
                  {/* Pagination & Page Size */}
                  <div className="pagination-container d-flex justify-content-between">
          <div style={{marginTop:"20px"}}>
            <label htmlFor="pageSizeSelect">Rows per page: </label>
            <select
              id="pageSizeSelect"
              value={pageSizePagination}
              onChange={handlePageSizeChange}
              style={{ marginLeft: "10px" }}
            >
                  <option value={10}>10</option>
              <option value={25}>25</option>
              <option value={50}>50</option>
              <option value={100}>100</option>
              <option value={250}>250</option>
              <option value={500}>500</option>
            </select>
          </div>
          <PaginationAndSearching
                  handleSearch={handleSearchPagination}
                  searchValue={searchValuePagination}
                  defaultValue={pageSizePagination}
                  handleChangeRowsPerPage={handleChangeRowsPerPagePagination}
                  totalCount={totalCountPagination}
                  onChange={(e,p)=>{
                    handleOnChangePagination(e,p)
                    // setCheckedRows([])
                  }}
                />
                </div>
        </div>
      </div>
    </>
  );
};
export default CancelledPropertyListTable;
